module.exports = function getConceptSchemeTitle(conceptScheme) {
  return {
    'food-beverage': 'Caterers & Bartenders',
    food: 'Caterers',
    beverage: 'Bartenders',
    venues: 'Venues',
    entertainment: 'Entertainment',
  }[conceptScheme];
};
